import { render, staticRenderFns } from "./CommonStringForm.vue?vue&type=template&id=a271bd2e&"
import script from "./CommonStringForm.vue?vue&type=script&lang=js&"
export * from "./CommonStringForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports